<template>
    <div class="row">
        <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
        </div>
        <div v-if="Object.entries(jobStack).length">
            <div class="card">
                <div class="card-body">
                    <form-fields :fields="jobStackFields" v-model="jobStack" :inlineField=true
                        :editMode="editModeStack" />
                </div>
            </div>
            <div>
                <div class="card">
                    <div>
                        <Datatable customTitle="Add Job" customClass="btn btn-primary"
                            :tableTitle="`Template Jobs for ${jobStack.name}`" @customActionButton="onAddJobStackJobs"
                            tableId="jobStackJobsListTable" :columns="columns" uniqueField="name"
                            :data="jobStackJobList" :deletable="true" @deleteRows="showDelete" :compact="true"
                            :selectCheckboxes="true" :editable="editDisable" :orderColumn="orderColumn"
                            :showLoading="false"
                            />
                    </div>
                    <div v-if="jobStack && !loading">
                        <div class="card-body" v-if="pipelineJobConfig" style="height: 600px;">
                            <PipelineGraph :pipelineJobConfig="pipelineJobConfig" :jobs="templateJobs"
                                :showresetViewBtn="true" @resetView="resetViewTrigger++" :key="`pipeline-${jobStack?.name}-${resetViewTrigger}`"/>
                        </div>
                        <div class="card-body" v-else>
                            <VueflowGraph :data="graphData" :name="jobStack.name" :hoverData="graphHoverData">
                            </VueflowGraph>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="text-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</template>
<script>
import Datatable from '../../components/Datatable.vue';
import { mapActions } from 'vuex';
import VueflowGraph from '../../components/VueflowGraph.vue';
import PipelineGraph from '../agm/pipelineGraph.vue';
import Fields from '../../utils/field-constants/jobStackFields';
import FormFields from '../../components/FormFields.vue';
import cron from "cron-validate";
import cronstrue from "cronstrue";
export default {
    name: "JobStack",
    components: { Datatable, VueflowGraph, FormFields, PipelineGraph },
    data() {
        var self=this;
        return {
            loading: false,
            tag: null,
            jobStack: {},
            jobStackJobList: [],
            snapshot: null,
            error: null,
            columns: [
                { data: "name", title: "name", orderable: false },
                { data: "schedule", title: "schedule", orderable: false,
                    render: function (data, type, row) {
                        const description = self.validateCron(data);
                        if (description) {
                            return `<span title="${description}">${data}</span>`;
                        }
                        return data || '';
                    },
                 },
                {
                    data: "meters", title: "is metered",
                    render: function (data, type, row) {
                        return data?.length ? "Yes" : "No";
                    },
                },
                {
                    data:"git_commit", title: "commit (trunc)",
                    render: function (data, type, row) {
                        return data ? data.slice(0, 8) : null;
                    },
                }
            ],
            orderColumn: [3, "asc"],
            editDisable: false,
            config: [],
            graphData: [],
            graphHoverData: ["name", "schedule"],
            typeOptions: [
                { label: "Internal", value: "internal" },
                { label: "External", value: "external" }
            ],
            jobStackFields: JSON.parse(JSON.stringify(Fields)),

            pipelineJob: null,
            pipelineJobConfig: null,
            templateJobs: [],
            resetViewTrigger: 0,
        }
    },
    props: ["editModeStack", "saveJobStack", "cancelClickStack"],
    beforeMount() {
        this.fetchJobStack();
        this.$emit("hideEditBtnStack", false);
        this.$emit("triggerEditModeStack", false);
        this.jobStackFields = this.jobStackFields.map((field) => {
            if (field.name === 'jobs') {
                field.visible = false;
            }
            if (field.name === 'name') {
                field.editable = false;
                delete field.helpText
                delete field.validation
            }
            return field
        })
    },
    watch:{
        editModeStack(val) {
            if (val) {
                this.error = "";
                this.response = "";
            }
        },
        saveJobStack() {
            this.onSaveJobStack();
        },
        cancelClick() {
            this.fetchJobStack();
        },
        cancelClickStack() {
            this.fetchJobStack();
        },
        'jobStack.jobs'(newVal) {
            if (newVal)
                this.graphData = newVal.map((job) => {
                    return {
                        jobId: job.name,
                        jobDetails: job,
                        error: null
                    }
                })
        }
    },
    methods: {
        ...mapActions({
            readTemplateJob: "amdp/readTemplateJob",
            readJobStack: "amdp/readJobStack",
            upsertJobStack: "amdp/upsertJobStack",
            deleteJobStack: "amdp/deleteJobStack",
            showModal: "showModal",
        }),
        setEditDisable(mode){
            this.editDisable = mode;
        },
        async fetchJobStack() {
            this.loading = true;
            let response = {};
            try {
                response = await this.readJobStack(this.$route.params.name);
            } catch (error) {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
            }
            this.jobStack = await response.data;
            this.jobStackJobList = this.jobStack.jobs;

            this.snapshot = JSON.parse(JSON.stringify(this.jobStack));

            this.pipelineJob = this.jobStackJobList.find(job => job.job_kind.toLowerCase() === 'pipeline');
            if (this.pipelineJob?.name) {
                const resp = await this.readTemplateJob(this.pipelineJob.name);
                if (resp?.data) {
                    this.pipelineJobConfig = resp.data;
                }
                let templateJobs = {};
                this.templateJobs = this.jobStackJobList.map(job => {
                    templateJobs[job.name] = {
                        name: job.name,
                        kind: job.job_kind,
                    }
                });
                this.templateJobs = JSON.parse(JSON.stringify(templateJobs));
            }
            this.$emit("setJobStack", this.jobStack);
            this.$emit("setShowJobStack", this.jobStack.name? true: false);
            this.loading = false;
        },
        async onSaveJobStack() {
            let self = this;
            let toastoptions;
            this.error =null;
            let jobStack ={...this.jobStack};
            jobStack.jobs =jobStack.jobs.map(job => job.name);
            delete jobStack["created_at"]
            delete jobStack["created_by"]
            delete jobStack["updated_at"]
            delete jobStack["updated_by"]
            try {
                const response = await this.upsertJobStack(jobStack);
                this.snapshot = JSON.parse(JSON.stringify(this.jobStack));
                toastoptions = {
                    message: "Job Stack updated successfully.",
                    type: "success",
                };
            } catch (error) {
                if (error.response.data.error)
                    self.error = error.response.data.error;
                else self.error = error.message;
                toastoptions = {
                    message:
                        this.error ||
                        "Something went wrong when updating Job Stack. Please contact support.",
                    type: "error",
                };
            } finally {
                this.loading = false;
                this.$emit("triggerEditModeStack", false);
                this.$emit("hideEditBtnStack", false);
                this.$store.dispatch("addToast", toastoptions);
            }
        },
        showDelete(rows) {
            let list =this.jobStack.jobs;
            for (const item of rows) {
                list = list.filter(job => job.name !==  item.name);
            }
            this.showModal({ component: "DeleteJobStackList", data: { list: list, rows: rows, onSaveChange:this.onSaveChange } });
        },
        async onSaveChange(list){
            this.jobStack.jobs= list;
            await this.onSaveJobStack();
            this.fetchJobStack();
        },
        onAddJobStackJobs(){
            let list = this.jobStack.jobs.map(job => job.name);
            this.showModal({ component: 'AddJobStackJob', data: { name: this.jobStack.name,list: list, onSaveChange: this.onSaveChange } })
        },
        validateCron(val) {
            let cronDescription= null;
			if ( val && val !== "" && val !== "DISABLED") {
				const cronResult = cron(val, { preset: "aws-cloud-watch" });
				if (cronResult.isValid()) {
					cronDescription = cronstrue.toString(val);
				}
			} else {
				cronDescription = null;
			}
            return cronDescription;
		},
    },
    emits: [
        "setJobStack", "setShowJobStack", "hideEditBtnStack","triggerEditModeStack"
    ],
}
</script>
<style></style>